export default {"src":"/_next/static/media/curation_4.404abca0.gif","height":500,"width":700,"blurWidth":0,"blurHeight":0};